import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FieldType, FormlyModule } from '@ngx-formly/core';

@Component({
  selector: 'gk-formly-typeahead',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    FormlyModule,
  ],
  template: `
    <input
      type="text"
      [formControl]="$any(formControl)"
      [formlyAttributes]="field"
      [ngbTypeahead]="to['typeahead']?.search"
      [inputFormatter]="to['typeahead']?.formatter"
      [resultFormatter]="to['typeahead']?.formatter"
      [placeholder]="to.placeholder"
      [ngClass]="to['className']"
      [attr.aria-required]="to['aria-required']"
      [attr.autocomplete]="to.attributes?.['autocomplete']"
      [attr.maxlength]="to.attributes?.['maxlength']"
      (blur)="to['onBlur']?.(field)"
    />
  `,
})
export class GkFormlyTypeaheadComponent extends FieldType {}
